export default __webpack_public_path__ + "static/media/icon_pager.b8b81b02.svg";